/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CreatorFileProcessingResponseFromJSON, SubmitIncidentReportRequestToJSON, UpdateCrashLinkRequestToJSON, ViewIncidentReportResponseFromJSON, ViewIncidentReportResponsePageResponseFromJSON, } from '../models/index';
/**
 *
 */
export class CreatorIncidentReportsApi extends runtime.BaseAPI {
    /**
     */
    creatorIncidentReportsFetchReportByIncidentReportIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.incidentReportId === null || requestParameters.incidentReportId === undefined) {
                throw new runtime.RequiredError('incidentReportId', 'Required parameter requestParameters.incidentReportId was null or undefined when calling creatorIncidentReportsFetchReportByIncidentReportId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports/{incidentReportId}`.replace(`{${"incidentReportId"}}`, encodeURIComponent(String(requestParameters.incidentReportId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentReportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentReportsFetchReportByIncidentReportId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentReportsFetchReportByIncidentReportIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentReportsGetProcessingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.reportIds) {
                queryParameters['reportIds'] = requestParameters.reportIds;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports/processing`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreatorFileProcessingResponseFromJSON));
        });
    }
    /**
     */
    creatorIncidentReportsGetProcessing(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentReportsGetProcessingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentReportsPaginateReportsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentReportResponsePageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentReportsPaginateReports(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentReportsPaginateReportsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentReportsRemoveFileByIncidentReportIdAndFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.incidentReportId === null || requestParameters.incidentReportId === undefined) {
                throw new runtime.RequiredError('incidentReportId', 'Required parameter requestParameters.incidentReportId was null or undefined when calling creatorIncidentReportsRemoveFileByIncidentReportIdAndFileId.');
            }
            if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                throw new runtime.RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling creatorIncidentReportsRemoveFileByIncidentReportIdAndFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports/{incidentReportId}/files/{fileId}`.replace(`{${"incidentReportId"}}`, encodeURIComponent(String(requestParameters.incidentReportId))).replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    creatorIncidentReportsRemoveFileByIncidentReportIdAndFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.creatorIncidentReportsRemoveFileByIncidentReportIdAndFileIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    creatorIncidentReportsSetCrashLinkByIncidentReportIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.incidentReportId === null || requestParameters.incidentReportId === undefined) {
                throw new runtime.RequiredError('incidentReportId', 'Required parameter requestParameters.incidentReportId was null or undefined when calling creatorIncidentReportsSetCrashLinkByIncidentReportId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports/{incidentReportId}/crash-link`.replace(`{${"incidentReportId"}}`, encodeURIComponent(String(requestParameters.incidentReportId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCrashLinkRequestToJSON(requestParameters.updateCrashLinkRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentReportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentReportsSetCrashLinkByIncidentReportId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentReportsSetCrashLinkByIncidentReportIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentReportsSubmitReportRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/creator/incident-reports`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SubmitIncidentReportRequestToJSON(requestParameters.submitIncidentReportRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentReportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentReportsSubmitReport(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentReportsSubmitReportRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
